module.exports = __webpack_public_path__ + "media/images/hexa1-c86d07e17504e79835631ab2c523b70d.png";